var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSample(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3546 4.5309C12.4521 4.36198 12.3942 4.14598 12.2253 4.04845C12.0564 3.95092 11.8404 4.00877 11.7429 4.17769L9.00177 8.92544C8.90424 9.09436 8.96213 9.31036 9.13105 9.40789C9.29997 9.50541 9.51597 9.44752 9.6135 9.2786L12.3546 4.5309ZM5.62013 6.72704C5.5226 6.89599 5.58049 7.112 5.74941 7.20952C5.91833 7.30705 6.13433 7.24916 6.23186 7.08024L8.86643 2.51701C8.96395 2.34809 8.90606 2.13208 8.73715 2.03456C8.56823 1.93703 8.35222 1.99492 8.25469 2.16384L5.62013 6.72704Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0179 3.17352L8.6761 0.0818548C8.59799 0.0366477 8.49802 0.0633202 8.45281 0.14143L7.61971 1.58088C7.5745 1.65899 7.60117 1.75896 7.67928 1.80416L13.0211 4.89583C13.0992 4.94104 13.1992 4.91437 13.2444 4.83626L14.0775 3.39681C14.1227 3.3187 14.096 3.21873 14.0179 3.17352Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41518 14.8183L9.61348 9.27874C9.15793 9.01573 8.80888 8.56824 8.35333 8.30523C7.89782 8.04225 7.33577 7.9637 6.88022 7.70069C6.42467 7.43767 6.07562 6.99019 5.62011 6.72717L2.3153 12.4513C1.66437 13.5787 2.05422 15.0338 3.18172 15.6847C4.30919 16.3357 5.76424 15.9458 6.41518 14.8183Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSample);
export default __webpack_public_path__ + "static/media/Sample.8ef246989624436ab6fc2fad1bda7832.svg";
export { ForwardRef as ReactComponent };